/**
 * Created by d.penning on 05.10.2017.
 */
import { TOGGLE_QUICK_BETTING } from './actionTypes'

export const toggleQuickBetting = (id: any) => ({
    type: TOGGLE_QUICK_BETTING,
    id,
})
